import React from 'react';
import { useSelector } from 'react-redux';

import UserDateFormat from '../../../components/user-date-format/index';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const ReceivedDateColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  if (!ret || !ret.receivedDateTime) {
    return '';
  }

  return <UserDateFormat value={ret.receivedDateTime} />;
};

export const RecievedDate = {
  getMessageDescriptor: () => messages.receivedDate,
  id: 'received-date',

  render: ({ fulfillmentId }) => {
    return <ReceivedDateColumn fulfillmentId={fulfillmentId} />;
  },
};
